module.exports = __webpack_public_path__ + "media/photo/Component 8 – 12@2x-31966dc8.jpg";